import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-close-icon',
  templateUrl: './lib-close-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibCloseIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
